"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractReadingValueFromSensorEventDeprecated = exports.extractReadingValueFromSensorEvent = void 0;
/**
 * Generic function to parse sensor readings into a strongly-typed object
 * @param sensorEvent The sensor event containing raw data
 * @returns A typed object representing sensor readings or null if parsing fails
 */
function extractReadingValueFromSensorEvent(sensorEvent) {
    if (!sensorEvent.values)
        return null;
    try {
        return sensorEvent.values;
    }
    catch (error) {
        console.error('Error parsing sensor readings:', error);
        return null;
    }
}
exports.extractReadingValueFromSensorEvent = extractReadingValueFromSensorEvent;
const READING_TYPE_KEY = 'type';
const READING_VALUE_KEY = 'value';
/**
 * Extracts a specific reading value from a sensor event based on the desired reading type.
 * @param sensorEvent The sensor event containing the value
 * @param desiredReadingType The type of reading to extract (e.g., 'temperature', 'humidity')
 * @returns The extracted reading value as a number, or null if not found or parsing fails
 */
const extractReadingValueFromSensorEventDeprecated = (sensorEvent, desiredReadingType) => {
    if (!sensorEvent.value)
        return null;
    try {
        const parsedReadings = JSON.parse(sensorEvent.value);
        // Workaround for the case where the value is a single number. not an object.
        // May not be necessary when there is real, valid data
        if (typeof parsedReadings === 'string' && !Number.isNaN(Number(parsedReadings))) {
            return Number(parsedReadings);
        }
        else if (typeof parsedReadings === 'number') {
            return parsedReadings;
        }
        const matchingReading = parsedReadings.find((reading) => reading[READING_TYPE_KEY] === desiredReadingType);
        if (!matchingReading || !matchingReading[READING_VALUE_KEY]) {
            return null;
        }
        return Number(matchingReading[READING_VALUE_KEY]);
    }
    catch (parsingError) {
        console.error('Error parsing sensor event value:', parsingError);
        return null;
    }
};
exports.extractReadingValueFromSensorEventDeprecated = extractReadingValueFromSensorEventDeprecated;
